/* eslint-disable no-param-reassign, import/no-extraneous-dependencies */
import React, { JSX, useCallback } from 'react';

import {
    DragEndParams,
    RenderItemParams,
} from 'react-native-draggable-flatlist';
import { useSharedValue } from 'react-native-reanimated';

import gStyles from 'config/styles';

import { ChannelsContent } from '../ChannelLineupItem/ChannelLineupItem';
import DraggableItem from '../DraggableItem/DraggableItem';

type Props = {
    data: ChannelsContent[];
    onDragEnd: (data: DragEndParams<ChannelsContent>) => void;
    renderItem: (
        listItemParams: RenderItemParams<ChannelsContent>,
    ) => JSX.Element;
    toggleChannelVisibility: (index: number) => void;
};

function DraggableList({
    data,
    onDragEnd,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    renderItem,
    toggleChannelVisibility,
}: Props) {
    const updateItemVisibility = useCallback(
        (index: number) => () => {
            if (typeof index === 'number') {
                toggleChannelVisibility(index);
            }
        },
        [toggleChannelVisibility],
    );

    const draggedIndex = useSharedValue<number | null>(null);
    const offsetY = useSharedValue(0);

    const handleMoveItem = useCallback(
        (fromIndex: number, toIndex: number) => {
            const newData = Array.from(data);
            const [removed] = newData.splice(fromIndex, 1);
            newData.splice(toIndex, 0, removed);

            draggedIndex.value = null;
            offsetY.value = 0;
            onDragEnd({
                data: newData,
            } as unknown as DragEndParams<ChannelsContent>);
        },
        [data, draggedIndex, offsetY, onDragEnd],
    );

    return (
        <div style={gStyles.settingsContentContainer}>
            {data.map((item, index) => (
                <DraggableItem
                    key={item.editorial.id}
                    item={item}
                    index={index}
                    draggedIndex={draggedIndex}
                    offsetY={offsetY}
                    moveItem={handleMoveItem}
                    updateItemVisibility={updateItemVisibility}
                />
            ))}
        </div>
    );
}

export default DraggableList;
